/* eslint-disable no-unsafe-optional-chaining */
import { getTokenFromCookies, setCookie } from '../../hooks/useCookie';
// import { checkCrossSellEligibility } from '../../integration/cross-sell.api';,
import {
  getSubscriptionWithEligibilityAndContactDetails,
  getCrossSellEligiblity,
} from '../../integration/eligibility.api';

/**
 * @function eligibilityCheck
 * @param {String} token -  Must be passed for if called from server-side
 * @param {Object} cookies - If token is not fetched from cookies then pass cookie object to retireve token
 * @returns {subscriptions, contactDetails, crossSellEligibility}
 */
export const eligibilityCheck = async ({ token = undefined, cookies }) => {
  try {
    const result = {};
    let retrievedToken = token;
    // if token is not passed get it from cookies [client-side]
    if (token === undefined) {
      // console.log('token is undefined');
      retrievedToken = getTokenFromCookies(cookies);
    }
    const { subscriptions, contactDetails } = await getSubscriptionWithEligibilityAndContactDetails(
      retrievedToken
    );
    result.subscriptions = subscriptions;
    result.contactDetails = contactDetails;
    const accountId = subscriptions?.filter(subs => subs.accountId)[0].accountId;
    if (accountId) setCookie('ION', 'account_Id', accountId);
    const customerName = contactDetails?.firstName;
    if (customerName) setCookie('ION', 'customer_Name', customerName);

    // if (accountId) {
    //   // console.log('eligiblity-check', accountId, Number(accountId), typeof Number(accountId));
    //   // get cross sell eligibility for MOBILE and DUALPLAY
    //   const { data } = await getCrossSellEligiblity({
    //     accountId: Number(accountId),
    //     token: retrievedToken,
    //   });
    //   result.crossSellEligibility = data;
    //   // get cross sell eligibilty for TV if DUALPLAY subscription is available
    //   let dualplaySubscriptions = subscriptions?.filter(
    //     subs => subs.serviceGroup === 'DUALPLAY' && subs.status === 'ACTIVE'
    //   );
    //   dualplaySubscriptions = dualplaySubscriptions.map(subs => subs.id);
    //   //   case 1: if no existing DUALPLAY subscription is available, cross-sell TV is not eligibile
    //   if (dualplaySubscriptions?.length === 0)
    //     result.crossSellEligibility.serviceGroups = result.crossSellEligibility.serviceGroups.map(
    //       obj =>
    //         obj.serviceGroup === 'TV'
    //           ? {
    //               ...obj,
    //               eligible: false,
    //               causes: 'User does not have any existing DUALPAY subscription',
    //             }
    //           : obj
    //     );
    //   // case 2: if only one existing DUALPLAY subscription is available, calling getCrossSellEligiblity with dualplay subscription
    //   else if (dualplaySubscriptions?.length === 1) {
    //     result.crossSellEligibility.serviceGroups = [];
    //     const results = { ...result };
    //     const csTVElg = await getCrossSellEligiblity({
    //       accountId,
    //       token: retrievedToken,
    //       parentSubscriptionId: `${dualplaySubscriptions[0]}`,
    //     });
    //     const tvData = csTVElg?.data.serviceGroups?.map(obj => {
    //       if (
    //         obj.serviceGroup === 'TV' ||
    //         obj.serviceGroup === 'MOBILE' ||
    //         obj.serviceGroup === 'DUALPLAY'
    //       )
    //         return { ...obj, dualplaySubscriptionId: dualplaySubscriptions[0] };
    //       return {};
    //     });
    //     const tempTvData = tvData?.filter(value => Object.keys(value).length !== 0);
    //     results.crossSellEligibility.serviceGroups = tempTvData;
    //     result = { ...results };
    //   }
    //   // case 3: If multiple existing DUALPLAY subscriptions are available
    //   else {
    //     result.crossSellEligibility.serviceGroups = [];
    //     let CSEligibilityData = [];
    //     const results = { ...result };
    //     const requests = dualplaySubscriptions.map(
    //       subscription =>
    //         // eslint-disable-next-line no-async-promise-executor
    //         new Promise(async (resolve, reject) => {
    //           try {
    //             const data1 = await getCrossSellEligiblity({
    //               accountId,
    //               token: retrievedToken,
    //               parentSubscriptionId: `${subscription}`,
    //             });
    //             resolve([data1, subscription]);
    //           } catch (err) {
    //             reject(err);
    //           }
    //         })
    //     );
    //     try {
    //       const promiseData = await Promise.allSettled(requests);

    //       let consData = promiseData.map(item1 => {
    //         const tvData = item1.value[0]?.data.serviceGroups?.map(obj => {
    //           if (
    //             obj.serviceGroup === 'TV' ||
    //             obj.serviceGroup === 'MOBILE' ||
    //             obj.serviceGroup === 'DUALPLAY'
    //           )
    //             return { ...obj, dualplaySubscriptionId: item1.value[1] };
    //           return {};
    //         });

    //         return tvData;
    //       });
    //       consData = consData.filter(item => item !== undefined && item);
    //       consData.forEach(item => {
    //         if (item?.length > 0) {
    //           CSEligibilityData = CSEligibilityData.concat(item);
    //         }
    //       });
    //       CSEligibilityData = CSEligibilityData?.filter(value => Object.keys(value).length !== 0);
    //       results.crossSellEligibility.serviceGroups = CSEligibilityData;
    //       result = { ...results };
    //     } catch (err) {
    //       results.crossSellEligibility.serviceGroups = [];
    //       result = { ...results };
    //       // console.error('err', err.graphQLErrors);
    //     }
    //   }
    // }
    return result;
  } catch (error) {
    console.error(error.graphQLErrors);
    // throw error;
  }
};
export const mobileEligibilityCheck = async ({ token = undefined, cookies }) => {
  try {
    const result = {};
    let retrievedToken = token;
    // if token is not passed get it from cookies [client-side]
    if (token === undefined) {
      // console.log('token is undefined');
      retrievedToken = getTokenFromCookies(cookies);
    }
    const { subscriptions, contactDetails } = await getSubscriptionWithEligibilityAndContactDetails(
      retrievedToken
    );
    result.subscriptions = subscriptions;
    result.contactDetails = contactDetails;
    const accountId = subscriptions?.filter(subs => subs.accountId)[0].accountId;
    if (accountId) setCookie('ION', 'account_Id', accountId);
    const customerName = contactDetails?.firstName;
    if (customerName) setCookie('ION', 'customer_Name', customerName);

    if (accountId) {
      // console.log('eligiblity-check', accountId, Number(accountId), typeof Number(accountId));
      // get cross sell eligibility for MOBILE and DUALPLAY
      const { data } = await getCrossSellEligiblity({
        accountId: Number(accountId),
        token: retrievedToken,
      });
      result.crossSellEligibility = data;
      return result;
    }
    return result;
  } catch (error) {
    console.log('error', error);
  }
};
